import { combineReducers, configureStore, type TypedStartListening } from '@reduxjs/toolkit';
import { reducers as application } from '@fogia/core-web/state/application';
import { reducers as customer } from '@fogia/core-web/state/customer';
import { INITIAL_STATE_KEY } from '@fogia/core-web/constants';
import searchReducer from '@fogia/core-web/state/models/Search/reducers';
import { reducer as page } from '@fogia/core-web/state/page';
import { reducer as server } from '@fogia/core-web/state/server';
// @TODO - prepared for enabling listeners in redux toolkit
// import { listenerMiddlewareInstance } from '@fogia/core-web/state/listenerMiddleware';

const isClient = typeof window !== 'undefined';

export const initiateStore = () => {
    const preloadedState = isClient && window[INITIAL_STATE_KEY] ? JSON.parse(window[INITIAL_STATE_KEY]) : {};

    const store = configureStore({
        reducer: {
            application: combineReducers(application), // @TODO: follow this structure
            customer,
            page,
            server,
            search: searchReducer,
        },
        preloadedState,
        devTools: true,
        // @TODO - prepared for enabling listeners in redux toolkit
        // middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddlewareInstance.middleware),
    });

    if (isClient) delete window[INITIAL_STATE_KEY];

    return store;
};

const store = initiateStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppStartListening = TypedStartListening<RootState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
